export default __webpack_public_path__ + "static/media/19.fb4c7655.jpg";